import { customLoadI18NextModule } from '../redux-module/sagas/prefetch-route/_utils/custom-load-i18next-module';
import { loadModule } from './load-and-inject/load-module';
export var getLoadModuleFetchConfig = function (_a) {
    var disableFetchI18n = _a.disableFetchI18n, config = _a.config, staticURL = _a.staticURL, name = _a.name, loadModuleFunction = _a.loadModuleFunction, router = _a.router, externalPackages = _a.externalPackages;
    // если disableFetchI18n или нет i18nNamespace то не надо запрашивать переводы
    if (disableFetchI18n || !(config === null || config === void 0 ? void 0 : config.i18nNamespace)) {
        return [
            loadModule({
                configData: config,
                staticURL: staticURL,
                name: name,
                loadModuleFunction: loadModuleFunction,
                externalPackages: externalPackages,
            }),
        ];
    }
    return [
        loadModule({
            configData: config,
            staticURL: staticURL,
            name: name,
            loadModuleFunction: loadModuleFunction,
            externalPackages: externalPackages,
        }),
        customLoadI18NextModule({
            namespaces: [config.i18nNamespace],
            router: router,
            version: config === null || config === void 0 ? void 0 : config.version,
        }),
    ];
};
